export const SET_ERROR = "SET_ERROR";

export const SAGA_SET_ERROR = "SAGA_SET_ERROR";
export const SAGA_RELOAD_ERROR = "SAGA_RELOAD_ERROR";

export class Saga {
  static setError(error) {
    return {
      type: SAGA_SET_ERROR,
      error: error
    }
  }
  static reload() {
    return {
      type: SAGA_RELOAD_ERROR
    }
  }
}

export class Generator {
  static setError(error) {
    return {
      type: SET_ERROR,
      error: error
    }
  }
}